import { isUrlPresent } from "owa-config";
import { findMetatag } from "owa-metatags";
import { isConsumer } from "owa-session-store";
import { getHostLocation } from "owa-url/lib/hostLocation";

export function isVanityDomain(): boolean {
    if (isConsumer()) {
        return false;
    }
    
    const publicUrl = (findMetatag("publicUrl") || "").toLowerCase();
    const origin = getHostLocation()?.origin.toLowerCase();
    const hostname = getHostLocation()?.hostname.toLowerCase();
    
    const OWAResourceUrls = [
        "outlook.office.com", // Prod
        "outlook-sdf.office.com", // SDF
        "outlook-tdf.office.com", // TDF
        "outlook.office365.com", // Prod
        "outlook-sdf.office365.com", // SDF
        "outlook.cloud.microsoft", // Prod
        "sdf.outlook.cloud.microsoft", // SDF
        "outlook-sdf.cloud.microsoft", // SDF
        "outlook.office365.us", // GCCH
        "outlook-dod.office365.us", // DOD
        "partner.outlook.cn", // Gallatin
    ];
    
    const WebmailMilUrl = "webmail.apps.mil";
    
    const PlacesResourceUrls = ["places.cloud.microsoft", "places-sdf.cloud.microsoft"];
    
    const NeswlettersResourceUrls: string[] = [];
    
    const AggregatedResourceUrls = [
        ...OWAResourceUrls,
        ...PlacesResourceUrls,
        ...NeswlettersResourceUrls,
        ...[WebmailMilUrl],
    ];
    
    /* gulp doesn't reliably set the publicUrl metaTag
        so we need to make sure it is a valid domain string first*/
    return (isUrlPresent(publicUrl) &&
        publicUrl !== origin &&
        !AggregatedResourceUrls.includes(hostname));
}
